const normalizeMap = (modules, base = "../assets/") =>
    Object.fromEntries(
        Object.entries(modules).map(([path, mod]) => [
            path.replace(base, ""),
            mod?.default ?? mod,
        ])
    );

const normalizeKey = (key = "") => {
    if (typeof key !== "string") return "";
    return key
        .replace(/^\/+/, "")
        .replace(/^src\/assets\//, "")
        .replace(/^assets\//, "")
        .replace(/^\.\/+/, "");
};

// URLs for any asset file (images, html, json, etc.)
const assetUrls = normalizeMap(
    import.meta.glob("../assets/**/*", { eager: true, query: "?url", import: "default" })
);

const jsonCache = {};
const readJsonByUrl = async (url) => {
    if (!url) return null;
    try {
        const response = await fetch(url, { cache: "force-cache" });
        if (!response.ok) return null;
        return await response.json();
    } catch {
        return null;
    }
};

export const getUrl = (key) => assetUrls[normalizeKey(key)] ?? null;
export const getJson = async (key) => {
    const normalized = normalizeKey(key);
    if (!normalized) return null;
    if (jsonCache[normalized]) return jsonCache[normalized];
    const data = await readJsonByUrl(assetUrls[normalized]);
    if (!data) return null;
    jsonCache[normalized] = data;
    return data;
};

export const ASSET_HELPERS = {
    urls: assetUrls,
    json: jsonCache,
    getUrl,
    getJson,
};

const useAssets = () => ASSET_HELPERS;

export default useAssets;
